(function () {

	const footer = () => {
		const footerDetails = document.querySelectorAll(
			'.footer .accordion details',
		);
		footerDetails.forEach((targetDetail) => {
			targetDetail.addEventListener('click', () => {
				footerDetails.forEach((detail) => {
					if (detail !== targetDetail) {
						detail.removeAttribute('open');
					}
				});
			});
		});

	}

	document.addEventListener('shopify:section:load', footer);
	footer();


	window.onload = function() {

		let output = document.getElementsByClassName("zify-navleft");

		const img = document.createElement("img");
		img.src = "https://cdn.shopify.com/s/files/1/1957/0713/files/left_arrow.png?v=1715042354";
		img.width = "25";
		output[0].appendChild(img);

		let output_r = document.getElementsByClassName("zify-navright");

		const img_r = document.createElement("img");
		img_r.src = "https://cdn.shopify.com/s/files/1/1957/0713/files/right_arrow.png?v=1715043441";
		img_r.width = "25";
		output_r[0].appendChild(img_r);

	}

	$(function() {
  
  $('table').on('mouseenter mouseleave', 'td', function(e) {
    (function(td, type) {
      td.parent()[type]('hover');
      td.closest('table').children('colgroup').eq(td.index())[type]('hover');
    })(
      $(this),
      e.type === 'mouseenter' ? 'addClass' : 'removeClass'
    );
  });
  
  // this verifies the dynamic nature of the above
  $('button').click(function(){
    $(this).parent().next().append('<tr><td></td><td></td><td></td><td></td><td></td></tr>');
  });
  
});

	

})();